/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2018, Zumper
 * @description Helper function to backfill similar listings
 */

import type { BuildingListingCollection } from '@zcode/bizos'
import * as ListC from '@zcode/nr/es/shared/constants/list'
import { checkIsUsableSimilarListing } from '@zcode/nr/es/shared/utils'
import type { Filters, Listable, Property } from '@zcode/state-type'
import type { MaybeEmpty } from '@zcode/utility-types'
import { logger } from '../logger'
import { loadMoreSimilarListings } from './similarListings'

interface GetBackfilledSimilarListingsArgs {
  checkIsFavorited: (listable: Listable) => boolean
  checkIsMessaged: (listable: Listable) => boolean
  entity: Listable | Property
  favorited: MaybeEmpty<BuildingListingCollection>
  filters: Filters
  forMultiMessage: true
  messaged: BuildingListingCollection
}

export const getBackFilledSimilarListings = async ({
  checkIsFavorited,
  checkIsMessaged,
  entity,
  favorited,
  filters,
  forMultiMessage,
  messaged,
}: GetBackfilledSimilarListingsArgs): Promise<readonly Listable[]> => {
  const isUsable = checkIsUsableSimilarListing({
    checkIsFavorited,
    checkIsMessaged,
  })

  // we don't have enough similar listing to display, get more
  // fetching start
  try {
    const result = await loadMoreSimilarListings({
      entity,
      favorited,
      filters,
      forMultiMessage,
      limit: ListC.SIMILAR_LISTABLES_API_LIMIT,
      messaged,
    })
    return result.filter(isUsable)
  } catch (error: unknown) {
    logger.error(error)
    return []
  }
}
